import React from "react";

/**
 * Indicador de carga.
 * Props:
 *  - size: "sm" | "md" | "lg"
 *  - label: texto accesible (screen readers) y opcionalmente visible con `showLabel`
 *  - showLabel: muestra el texto junto al spinner
 */
function Spinner({ size = "md", label = "Cargando...", showLabel = false, className = "" }) {
  return (
    <span className={`sw-ui-spinner-wrap ${className}`} role="status">
      <span className={`sw-ui-spinner sw-ui-spinner--${size}`} aria-hidden="true" />
      {showLabel ? (
        <span className="sw-ui-spinner-label">{label}</span>
      ) : (
        <span className="sw-ui-visually-hidden">{label}</span>
      )}
    </span>
  );
}

export default Spinner;
